import { AuthUserService, IAuthUser } from '../services/authusers.service';
import * as _ from "lodash";
class AuthSettingsUsersItemController implements ng.IComponentController {

    private authUser: IAuthUser;
    private fieldedit: any;
    private roleedit: any;

    constructor(private AuthUserService: AuthUserService) {
        'ngInject';
    }

    public $onInit = () => {
        this.AuthUserService.getRoles(this.authUser).then((roles) => {
            this.authUser.roles = roles;
        });

        this.AuthUserService.getClaims(this.authUser).then((claims) => {
            this.authUser.claims = new Object();
            for(var i = 0; i < claims.length; i++){
                var item = claims[i];
                this.authUser.claims[item.type] = item.value;
            }
            // console.log(this.authUser.claims);
        });
    }

    public save = () => {

        this.AuthUserService.post(this.authUser).then((response) => {
            // console.log(response);
        })

    }

    public createAccount = () => {
        this.authUser.userName = this.authUser.email;

        this.authUser.claims = {
            "displayName" : this.authUser.displayName,
        }

        this.authUser.roles = ['employee'];

        this.AuthUserService.post(this.authUser).then((response) => {
           // console.log('Account created');
        })
    }

     public updateUser = () => {
        this.AuthUserService.put(this.authUser.id, this.authUser).then((response) => {
           // console.log('Account created')
        })
    }

    public resetPassword = () => {
        //this.account = new IAuthUser();

        this.AuthUserService.resetPassword(this.authUser).then((response) => {
            //this.accountError = response;
           // console.log('Password reset')
        })
    }


    public editField = (index = null, value = null) => {
        this.deleteField(index, value);
        this.fieldedit.name = index;
        this.fieldedit.value = value;
    }

    public deleteField = (index = null, value = null) => {
        _.unset(this.authUser.claims, index);
    }

    public saveFields = () => {
        if(!this.authUser.claims) {
              this.authUser.claims = {};
        }
        this.authUser.claims[this.fieldedit.name] = this.fieldedit.value;
        this.fieldedit.name = null;
        this.fieldedit.value = null;
    }

    public editRole = (index = null, value = null) => {
        this.deleteRole(index, value);
        this.roleedit.name = value;
    }

    public deleteRole = (index = null, value = null) => {
        this.authUser.roles.splice(index, 1)
    }

    public saveRole = () => {
        if(!this.authUser.roles) {
              this.authUser.roles = [];
        }
        this.authUser.roles.push(this.roleedit.name);
        this.roleedit.name = null;
    }
}

export const authSettingsUsersItemComponent: ng.IComponentOptions = {
    bindings: {
        authUser: "<"
    },
    controller: AuthSettingsUsersItemController,
    template: require('./authsettings.usersItem.html')
};



// WEBPACK FOOTER //
// ./src/app/authsettings/components/authsettings.usersItem.component.ts